import React, { useState } from "react";
import CustomSelectStyles from "./CustomSelect.module.scss";
import {CustomSelectProps, Option} from "../../entity/index.entity";

const CustomSelect = ({ options, onChange }: CustomSelectProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(options[0].name);

    const handleOptionClick = (option: Option) => {
        setSelectedOption(option.name);
        setIsOpen(false);
        onChange(option.slug);
    };

    return (
        <div className={isOpen ? `${CustomSelectStyles.selectWrapper} ${CustomSelectStyles.open}` : CustomSelectStyles.selectWrapper}>
            <div
                className={CustomSelectStyles.categorySelect}
                onClick={() => setIsOpen(!isOpen)}
            >
                {selectedOption}
            </div>
            {isOpen && (
                <div className={CustomSelectStyles.optionsList}>
                    {options.map((option) => (
                        <div
                            key={option.slug}
                            className={`${CustomSelectStyles.optionItem} ${selectedOption === option.name ? CustomSelectStyles.selected : ''}`}
                            onClick={() => handleOptionClick(option)}
                        >
                            {option.name}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomSelect;
